export namespace LearningSupportType {
  export enum Values {
    GENIALLY = 'GENIALLY',
    HTML = 'HTML'
  }

  export function label(support: Values) {
    switch (support) {
      case Values.GENIALLY:
        return 'Lien Genially'
      case Values.HTML:
        return 'Fichier HTML'
    }
  }
}
